module.exports = __webpack_public_path__ + "img/Srbija.fa22f648.png";